import React from 'react';
import { Icon } from 'components/atoms';
import { SidebarMenuItemProps } from 'types/components.types';

const SidebarMenuItem: React.FC<SidebarMenuItemProps> = ({
  icon,
  text,
  shortcut,
  isActive: _isActive = false,
  onClick,
  variant = 'default',
  isCollapsed = false,
  className = ''
}) => {
  const isPrimary = variant === 'primary';

  const baseClasses = 'w-full flex items-center rounded-[10px] cursor-pointer transition-all';

  const variantClasses = isPrimary
    ? 'bg-white border border-[#e1e4ea] shadow-[0px_0px_2px_0px_rgba(0,0,0,0.03),0px_1px_5px_0px_rgba(0,0,0,0.04)] p-[10px]'
    : 'p-[10px] hover:bg-gray-50';

  const textClasses = isPrimary
    ? 'text-[#262626] text-[12px] font-medium'
    : 'text-[#262626] text-[12px] font-medium';

  if (isCollapsed) {
    return (
      <button
        className={`${baseClasses} justify-center ${variantClasses} ${className}`}
        onClick={onClick}
        type="button"
        title={text}
      >
        {icon && <Icon name={icon} className="w-5 h-5" />}
      </button>
    );
  }

  return (
    <button
      className={`${baseClasses} justify-between ${variantClasses} ${className}`}
      onClick={onClick}
      type="button"
    >
      <div className="flex items-center gap-2">
        {icon && <Icon name={icon} className="w-5 h-5" />}
        <span className={textClasses}>{text}</span>
      </div>
      {shortcut && (
        <div className="bg-white border border-[#e1e4ea] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.06)] rounded-[4px] px-2 flex items-center gap-1 h-5">
          <span className="text-[#99a0ae] text-[10px] font-medium leading-[1.2]">{shortcut}</span>
        </div>
      )}
    </button>
  );
};

export default SidebarMenuItem;
